export enum ArchType {
  Upper = 1,
  Lower = 2,
  Both = 3,
}
